import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
  padded?: boolean;
}

export function Card({ hover, padded = true, className, children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={cn('card', hover && 'card-hover', padded && 'p-5 sm:p-6', className)}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="mb-4 flex items-start justify-between gap-4">
      <h2 className="text-[17px] font-semibold text-ink">{children}</h2>
      {action}
    </div>
  );
}

interface StatCardProps {
  label: string;
  value: ReactNode;
  hint?: string;
  /** Selisih dari periode sebelumnya. Positif = naik. */
  delta?: number;
  /** Untuk metrik yang naiknya justru buruk (mis. temuan Open). */
  invertDelta?: boolean;
  /** Warna angka saat nilainya sendiri sudah bermakna (mis. ada tunggakan). */
  tone?: 'default' | 'warn' | 'success';
}

export function StatCard({ label, value, hint, delta, invertDelta, tone }: StatCardProps) {
  const good = delta === undefined ? null : invertDelta ? delta <= 0 : delta >= 0;

  return (
    <div className="card card-hover p-5">
      <p className="text-[13px] font-medium text-ink-secondary">{label}</p>
      <p
        className={cn(
          'tabular mt-2 text-[32px] leading-10 font-semibold',
          tone === 'warn' ? 'text-[#9a6400]' : tone === 'success' ? 'text-success' : 'text-ink',
        )}
      >
        {value}
      </p>
      <div className="mt-1 flex items-center gap-2 text-[13px]">
        {delta !== undefined && (
          <span className={cn('font-medium', good ? 'text-success' : 'text-danger')}>
            {delta >= 0 ? '▲' : '▼'} {Math.abs(delta)}
          </span>
        )}
        {hint && <span className="text-ink-muted">{hint}</span>}
      </div>
    </div>
  );
}
